import { useState, useEffect } from "react";
import "./App.css";
import ScraperDashboard from "./ScraperDashboard";
import PairingPage from "./PairingPage";
import DashboardPaired from "./dashboardpaired";
import Login from "./Login";

export default function App() {
  const [page, setPage] = useState("products");
  const [showScroll, setShowScroll] = useState(false);
  const [auth, setAuth] = useState(localStorage.getItem("authenticated") === "true");

  const handleLogin = () => {
    setAuth(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("authenticated");
    setAuth(false);
  };

  function toggleDarkMode() {
    const isDarkMode = document.body.classList.toggle("dark-mode");
    localStorage.setItem("dark-mode", isDarkMode ? "enabled" : "disabled");
  }

  useEffect(() => {
    if (localStorage.getItem("dark-mode") === "enabled" || localStorage.getItem("dark-mode") === null) {
      document.body.classList.add("dark-mode");
    }
  }, []);

  useEffect(() => {
    const checkScroll = () => setShowScroll(window.scrollY > 300);
    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  if (!auth) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="container">
      <nav className="navbar top-nav">
        <button onClick={() => setPage("products")} className={`nav-button ${page === "products" ? "active" : ""}`}>
          📦 Správa Scraperů
        </button>
        <button onClick={() => setPage("pairedProducts")} className={`nav-button ${page === "pairedProducts" ? "active" : ""}`}>
          📊 Přehled cen
        </button>
        <button onClick={() => setPage("pairing")} className={`nav-button ${page === "pairing" ? "active" : ""}`}>
          🔗 Párování
        </button>
        <button onClick={handleLogout} className="nav-button logout">
          🚪 Odhlásit se
        </button>
      </nav>

      {page === "products" && <ScraperDashboard />}
      {page === "pairing" && <PairingPage />}
      {page === "pairedProducts" && <DashboardPaired />}

      <button onClick={toggleDarkMode} className="floating-button dark-mode-toggle">🌙</button>
      {showScroll && (
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="floating-button scroll-to-top">⬆️</button>
      )}
    </div>
  );
}
